import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import * as Request from '../tgccRequest'
import { browserHistory } from 'react-router';
import AddressAutocomplete from '../Components/AddressAutoComplete'


declare var paymentTokenizationKey: string;
declare var braintree: any;
declare var ServerUrlRoot: string;

const paymentButtonId: string = 'payment-button';
const mobileBreakpoint = '@media (max-width: 768px)';

const checkoutContainer: React.CSSProperties = {
    backgroundColor: 'rgb(244, 250, 255)',
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '13px',
    padding: '5px',
    width: '100%',
    borderRadius: '20px',
    marginBottom: '20px',
    [mobileBreakpoint]: {
        borderRadius: '10px', // Optional: reduce border radius on mobile
        maxWidth: '100%',
        width: '100%',

      },
}
const userInfoContainer: React.CSSProperties = {
    backgroundColor: 'rgb(24, 17, 71)',
    width: '100%', // This makes the background color extend full width
    padding: '50px 0px',
    marginTop: '40px',
    [mobileBreakpoint]: {
        padding: '30px 10px', // Adjust padding for mobile
      },

};

const userInfoContent: React.CSSProperties = {
    maxWidth: '70%',
    marginRight: 'auto',
    marginLeft: 'auto',
    [mobileBreakpoint]: {
        maxWidth: '90%', // Increase max-width for mobile
      },
};



const rowHdrStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    height: '25px',
}
const cellStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #E9E6E6', // Color adjusted to match your design
    paddingBottom: '10px', // Add some space between the input and the border
    marginBottom: '10px', // Space to the next row
    fontFamily: 'Montserrat',
   
}

const connectorStyle: React.CSSProperties = {
    flexGrow: 1,
    borderBottom: '1px dotted #ccc', // or 'solid' if you prefer
    margin: '0 10px', // Adjust as needed
};


const isBlankOrEmpty = (str: string) => {
    if (!str)
        return true;
    if (!str.trim())
        return true;
    return false;
}
const rowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    margin: '10px 0', // Adjust the top and bottom margin to create space between rows
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    minHeight: '35px'
}

let szRowStyle = Object.assign({}, rowStyle, {
    justifyContent: 'space-between', // this ensures the items in the row are spaced out evenly
    alignItems: 'center', // this centers the items vertically
    margin: "0 30px",
    padding: '10px 0', // adjust padding as needed to match the image
  });
let btppStyle = Object.assign({}, rowStyle, { margin: "15px 30px" });
let btRowStyle = Object.assign({}, rowStyle, { margin: "0 30px", height: '340px' });

let checkoutButtonStyle: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    flexDirection: 'row',
    display: 'none'
}

const labelStyle: React.CSSProperties = {
    display: 'flex',
    letterSpacing: '2px',
    flexShrink: 1,
    flexGrow: 1
}

let szLblStyle = Object.assign({}, labelStyle, {
    fontSize: '12px',
    lineHeight: '20px',
    flexBasis: '120px',
    justifyContent: 'flex-end',
    marginRight: '3px',
    fontFamily: 'Lulo', // or the font family you see in the image
    color: '#somecolor', // replace with the color that matches the labels in the image
    textTransform: 'uppercase', // if the labels in the image are uppercase
  });
let szLblStyleStart = Object.assign({}, labelStyle, { flexBasis: '90px', justifyContent: 'flex-start', marginRight: '3px' });
let szLblStylePlain = Object.assign({}, labelStyle, { textTransform: 'none' })
let szLblStyleSmallEnd = Object.assign({}, labelStyle, { textTransform: 'lowercase', justifyContent: 'flex-end' })
const szDivider = Object.assign({}, labelStyle, { flexBasis: '30px' });

const inputStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    backgroundColor: 'white',
    lineHeight: '18px',
    height: '18px',
    width: '100px',
    marginLeft: '3px',
    padding: '2px',
    fontSize: '13px',
    display: 'flex',
    flexShrink: 1,
    flexGrow: 1,
    border: '1px solid #E9E6E6'
}

const priceTotalContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '20px', // Adjust as needed for spacing
  };
  
  const priceRowStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px', // Adjust as needed for spacing
  };
  
  const totalRowStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px', // Adjust as needed for spacing
  };
  
  const priceLabelStyle: React.CSSProperties = {
    marginRight: '10px', // Adjust as needed for spacing
    lineHeight: '20px',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    color: 'rgb(58, 84, 180)',
    fontSize: '18px',
    textShadow: '1px 1px 2px',
    fontWeight: 900,
  }

  const priceValueStyle: React.CSSProperties = {
    // Add styling as needed
    lineHeight: '20px',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    color: 'rgb(58, 84, 180)',
    fontSize: '18px',
    textShadow: '1px 1px 2px',
  };
  
  const totalLabelStyle: React.CSSProperties = {
    marginRight: '10px', // Adjust as needed for spacing
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 'bold',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    color: 'rgb(58, 84, 180)',
    margin: '15px',
    textShadow: '1px 1px 2px',
    // Add other styling as needed
  };
  
  const totalValueStyle: React.CSSProperties = {
    marginRight: '10px', // Adjust as needed for spacing
    fontSize: '16px',
    lineHeight: '20px',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    color: 'rgb(58, 84, 180)',
    textShadow: '1px 1px 2px',
  };

const userInfoRowStyle: React.CSSProperties = {
    margin: '20px 0px', // Adjust the space between each row
    display: 'flex',
    alignItems: 'center', // Center the items horizontally
    width: '100%', // Ensure it spans the width of its container
}

const headerStyle: React.CSSProperties = {
    color: '#fff', // Assuming white text color from the image
    textAlign: 'center',
    fontSize: '2em', // Adjust the font size as needed
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    fontWeight: 'bold',
    marginBottom: '0.5em', // Spacing below the header
  };
  
  const subheaderStyle: React.CSSProperties = {
    color: '#ddd', // Lighter color for the subheader, adjust as needed
    textAlign: 'center',
    fontSize: '1em',
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    marginBottom: '2em', // More spacing below the subheader to separate from the form
    maxWidth: '600px', // Ensuring the subheader does not span too wide
    marginRight: 'auto',
    marginLeft: 'auto',
  };
  
const userInfoLabelStyle: React.CSSProperties = {
    color: 'white', // Assuming the label text color is white as per your theme
    textAlign: 'center',
    marginBottom: '10px', // Space between the label and the input field
    fontSize: '16px', // You can adjust this to match your design
    width: '100%', // Labels should also span the full width to center align text properly
}

const userInfoInputStyle: React.CSSProperties = {
    width: '25%', // As per your request, adjust if necessary
    padding: '10px 15px', // Provide ample padding for the input
    margin: '0 auto', // Center the input within the row
    border: '1px solid #ccc', // A light border as per standard input style, adjust as necessary
    borderRadius: '4px', // Optional, if you want rounded corners
    fontSize: '16px', // Match the font size to your label for consistency
    color: 'black', // Input text color, assuming it should be black for visibility
    background: 'white', // Assuming a white background for input fields
    [mobileBreakpoint]: {
        width: '100%', //
    }
}


let nameLblStyle = { flexBasis: '90px', fontFamily: 'Lulo' };
let emailLblStyle = { flexBasis: '70px', fontFamily: 'Lulo' };
let nameStyle = Object.assign({}, inputStyle, { flexBasis: '140px', fontFamily: 'BarlowLight' });
let emailStyle = Object.assign({}, inputStyle, { flexBasis: '310px', fontFamily: 'BarlowLight' });
let numberStyle = Object.assign({}, {
    width: '60px',
    textAlign: 'center',
    padding: '5px',
    border: '0.5px solid rgb(58, 84, 180)',
    borderRadius: '7px',
    fontFamily: 'Montserrat',
    backgroundColor: '#f4f4f4',
    [mobileBreakpoint]: {
        marginBottom: '10px', // Space below each input

    }
  });
let addrlineStyle = Object.assign({}, inputStyle, { width: '317px', marginRight: "10px", fontFamily: 'BarlowLight' });
let cityStyle = Object.assign({}, inputStyle, { width: '160px', marginRight: "10px", fontFamily: 'BarlowLight' });
let stateStyle = Object.assign({}, inputStyle, { width: '40px', maxlength: 2, marginRight: "10px", fontFamily: 'BarlowLight' });
let zipStyle = Object.assign({}, inputStyle, { width: '65px', maxlength: 10, marginRight: "10px", fontFamily: 'BarlowLight' });
let errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '13px', maxWidth: '100%', padding: '0 10px' });
let hdrStyle = Object.assign({}, labelStyle, { fontSize: '16px', fontWeight: 'bold', display: 'block', textAlign: "center", marginBottom: '10px' });
let checkLabelStyle = Object.assign({}, labelStyle, { fontWeight: 'normal', letterSpacing: '1.2px', fontSize: '12px', textAlign: "center", flexShrink: 'none', flexGrow: 'none' });
let checkRowStyle = Object.assign({}, rowStyle, { flexGrow: 'none', justifyContent: 'space-around' })

const shipCheckStyle: React.CSSProperties = {
    display: 'flex',
    lineHeight: '22px',
    height: '15px',
    width: '15px',
    alignSelf: 'baseline'
}

const proseStyle: React.CSSProperties = {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    margin: '40px auto',
    width: '60%',
    fontFamily: 'BarlowMedium',
    textTransform: 'none',
    textAlign: 'center',
    padding: '0,10,0,10',
    '@media (max-width: 768px)': {
        margin: '0', // Removes margin on mobile
        width: '100%', // Sets width to 100% on mobile
    },
}

const hrStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    width: '85%',
    margin: '15px 0'
}

const venmoStyle: React.CSSProperties = {
    content: 'url(' + Tgcc.ResolveUrl('~/images/venmo.png') + ')',
    width: 180,
    height: 35
}

const scriptStyle: React.CSSProperties = {
    height: '45px',
    lineHeight: '45px',
    fontSize: '40px',
    fontFamily: 'BarlowMedium',
    textTransform: 'none',
    textAlign: 'center'
}

const paymentDisabledStyle: React.CSSProperties = {
    content: 'url(' + Tgcc.ResolveUrl('~/images/paymentbraintree.png') + ')',
    height: '25px',
    opacity: 0.7
}

const textStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '10px'
}

const shipHighlightColor: string = '#D47C61';

const inlineHighlightAllCaps: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase'
}
const inlineHighlightAllCapsBold: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase',
    fontWeight: 'bold'
}
const inlineHighlightBold: React.CSSProperties = {
    fontWeight: 'bold',
    textTransform: 'uppercase'
}
const shipHdrStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 'bold',
    letterSpacing: '2.8px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: shipHighlightColor,
    marginBottom: '10px'
}

const greekLetterHdr: React.CSSProperties = {
    color: 'red',
    fontSize: '11px'
}
const ckRosterStyle: React.CSSProperties = {
    textAlign: 'center',
    padding: '5px',
    border: '1px solid grey',
    cursor: 'pointer',
    backgroundColor: '#57B056',
    color: 'white'
}
const shipBtn: React.CSSProperties = {
    textAlign: 'center',
    width: '225px',
    height: '30px',
    margin: 'auto',
    backgroundColor: '#A6A6A6',
    lineHeight: '31px',
    borderRadius: '20px',
    color: 'white',
    fontFamily: 'Lulo'
}
const orderNowBtn: React.CSSProperties = {
    backgroundColor: 'green',
    color: 'white',
    width: '75%',
    margin: '10px auto',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    letterSpacing: '1px',
    pointer: 'cursor',
    textTransform: 'uppercase'
}

// Parent container holding both sections
const sizeSelectionContainerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between', // This will space out the child elements evenly
    padding: '10px',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // More subtle shadow
    width: '100%', // Instead of 50%, so it takes the full width available
    boxSizing: 'border-box', // This ensures the padding and border are included in the width
    margin: '0 auto', // Center the container
    maxWidth: '800px', // Max width can be set to align with your design requirements
    [mobileBreakpoint]: {
        display: 'block',
        alignItems: 'center',
    },
  };
  
  // Style for each section (Youth and Adult)
  const sectionHeaderStyle: React.CSSProperties = {
    fontFamily: '"RocknRoll One", sans-serif', // And here
    color: 'rgb(58, 84, 180)',
    margin: '15px',
    fontSize: '18px',
    fontWeight: 900,
    textDecoration: 'underline',
    [mobileBreakpoint]: {
        textAlign: 'center', // Center the text on mobile
        margin: '15px',
    },
  };
  
  // Header style (common for both Youth and Adult)
  const sizeSectionStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '0 20px',
    flex: 1,
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 'bold',
    flexBasis: '120px',
    justifyContent: 'flex-end',
    marginRight: '3px',
    fontFamily: '"RocknRoll One", sans-serif',
    textTransform: 'math-auto',
    [mobileBreakpoint]: {
        justifyContent: 'center',
        padding: '20px',

    },
  };

  const wrapperStyle: React.CSSProperties = {
    backgroundColor: 'white',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '13px',
    padding: '5px',
    width: '450px',
    maxWidth: '80%',
    borderRadius: '20px',
    marginBottom: '20px',
    [mobileBreakpoint]: {
        padding: '5px 0', // Only padding top and bottom, no padding on the sides
        width: '100vw', // viewport width to ensure it extends full width of the screen
        maxWidth: '100vw', // viewport width for max-width to ensure full width of the screen
        borderRadius: '0', // if you want to remove border-radius on mobile
        // Make sure there is no horizontal overflow
        overflowX: 'hidden',
    },
}



const sizesSelectionRowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white', // Assuming the text color in the image is white
    backgroundColor: '#2A2A72', // This should match the heading background color in the image
    margin: '0', // Resetting any default margins
    width: '100%', // Full width to spread across the column
    padding: '10px', // Adjust as needed for your design
    fontSize: '1.2rem', // Adjust the font size as needed
    fontWeight: 'bold', // For bold text
    textTransform: 'uppercase', // If you want all letters to be uppercase as in the image
}


const cellWrapperStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px',
    border: '3px solid rgb(24, 17, 71)',
    margin: '0 auto',
    maxWidth: '50%',
    backgroundColor: 'rgb(24, 17, 71)',
}
  
  // The individual size option container within each section
  const sizeOptionStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between', // Space between the size label and input box
    width: '80%', // Width of the size option, adjust as needed
    margin: '10px 0', // Margin for each size option
  };

  // Style for the main header
const sizesHeaderStyle: React.CSSProperties = {
    width: '100%', // Full width
    textAlign: 'center', // Center text
    padding: '20px 0', // Padding at the top and bottom
    backgroundColor: 'rgb(244, 250, 255)',
    color: '#333', // Dark grey text color, adjust as needed
    fontSize: '2em', // Large font size for the header
    fontWeight: 'bold', // Bold text
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    marginBottom: '10px', // Margin at the bottom to separate from the next element
  };
  
const headerInfoContainerStyle: React.CSSProperties = {
    backgroundColor: 'rgb(244, 250, 255)',
    padding: '20px', // Padding inside the container
    maxWidth: '800px',
    margin: '0 auto 30px auto',
};

  // Style for the subheaders (paragraphs)
const sizesSubheaderStyle: React.CSSProperties = {
    textAlign: 'center', // Center text
    color: '#333', // Dark grey text color, adjust as needed
    textTransform: 'math-auto',
    fontSize: '1em', // Smaller font size for the subheader
    margin: '10px 0', // Margin at the top and bottom for spacing
};

const inputFieldStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
        padding: '10px 15px',
        margin: '5px auto',
        border: '1px solid #ccc',
        borderRadius: '5px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        fontSize: '14px',
        color: '#333',
        outline: 'none',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        width: '90%', // Adjust as needed
        maxWidth: '300px', // Max width for larger screens
        ':hover': {
            borderColor: '#2A2A72',
        },
        ':focus': {
            borderColor: '#2A2A72',
            boxShadow: '0 0 5px rgba(42, 42, 114, 0.3)',
        }
}


const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});
class Props {
    tbanker: Tgcc.TbankerInfo;
    purchaseComplete: boolean;
}
import { StyleRoot } from 'radium';
export class TBankerPurchase extends React.Component<Props, any>{
    state = {
        error: null,
        isWaiting: false,
        disableEdits: false,
        Organization: "",
        FirstName: "",
        LastName: "",
        Email: "",
        SizeCounts: [],
        payment: null,
        purchaseComplete: false,
        venmoUser: null,
        cardNumber: null,
        individualShip: this.props.tbanker.shipType == Tgcc.ShipmentTypes.Individual, // default if only indi ship
        address1: '',
        address2: '',
        addrState: '',
        addrCity: '',
        addrZip: '',
        addressVerifyModel: new Tgcc.AddressVerifyModel(),
        isSingleSizeItem: false,
    }

    componentDidMount() {
        this.handleDynamicEdits();
    }

    loadError = (err: any) => {
        this.setState({ isWaiting: false });
        console.log("error loading tbanker: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    handleCountChange = (evt: React.FormEvent<HTMLInputElement>) => {

        var newSizes = Object.assign({}, this.state.SizeCounts);
        newSizes[evt.currentTarget.name] = evt.currentTarget.value;
        this.setState({ SizeCounts: newSizes }, () => {
            this.allFieldsAreValid();
        });
    }

    handleFieldChange = (evt: React.FormEvent<HTMLInputElement>) => {
        var fldChange = {};
        if (evt.currentTarget.type == 'number')
            fldChange[evt.currentTarget.name] = parseInt(evt.currentTarget.value);
        else
            fldChange[evt.currentTarget.name] = evt.currentTarget.value;

        var targetName = evt.currentTarget.name;
        this.setState(fldChange, () => {
            //initiate address validation if needed
            if (this.state.individualShip &&
                (targetName === 'address1'
                    || targetName === 'address2'
                    || targetName === 'addrCity'
                    || targetName === 'addrState'
                    || targetName === 'addrZip')) {
                this.verifyAddress();
            }

            this.allFieldsAreValid()
        });
    }
    
    getTotalCount = () => {
        var itemCt: number = 0;
        for (const [key, value] of Object.entries(this.state.SizeCounts)) {
            if (Number(value) > 0)
                itemCt += Number(value);
        }
        return itemCt;
    }
    
    
    countsAreNegative = () => {
        for (const [key, value] of Object.entries(this.state.SizeCounts)) {
            if (Number(value) < 0)
                return true;
        }
        return false;
    }

    emailIsValid = () => {
        return Tgcc.IsValidEmail(this.state.Email);
    }

    streetAddressNotEmpty = () => {
        return this.state.address1 && this.state.address1.length > 5;
    }

    cityIsValid = () => {
        return this.state.addrCity && this.state.addrCity.length > 1;
    }

    stateIsValid = () => {
        var states: Array<string> = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];
        return this.state.addrState && (states.indexOf(this.state.addrState.toString().toUpperCase()) >= 0);
    }

    zipIsValid = () => {
        var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
        return zipCodePattern.test(this.state.addrZip);
    }

    allFieldsAreValid = () => {
        var total = this.getTotalCount();

        if (this.countsAreNegative()) {
            this.setState({ error: 'Negative item count is not valid.', isWaiting: false });
            console.log("Error state:", this.state.error);  // Log here
            return false;
        }
    
        if (total < 1) {
            this.setState({ error: 'Please indicate at least one size to order.', isWaiting: false });
            console.log("Error state:", this.state.error);  // Log here
            return false;
        }

        else if (this.state.individualShip && !this.streetAddressNotEmpty())
            this.setState({ error: 'Address is not valid.', isWaiting: false });

        else if (this.state.individualShip && !this.cityIsValid())
            this.setState({ error: 'City  is not valid.', isWaiting: false });

        else if (this.state.individualShip && !this.stateIsValid())
            this.setState({ error: 'State  is not valid.', isWaiting: false });

        else if (this.state.individualShip && !this.zipIsValid())
            this.setState({ error: 'Zip Code  is not valid.', isWaiting: false });

        else if (!this.state.FirstName || !this.state.FirstName.trim())
            this.setState({ error: 'First name cannot be blank.', isWaiting: false });

        else if (!this.state.LastName || !this.state.LastName.trim())
            this.setState({ error: 'Last name cannot be blank.', isWaiting: false });

        else if (!this.emailIsValid())
            this.setState({ error: 'Email is not valid.', isWaiting: false });

        else if (!this.countsAreValid())
            this.setState({ error: 'Order exceeds single payment limit of $10,000', isWaiting: false });

        // else if (this.state.individualShip && !this.addressIsVerified())
        //     this.setState({ error: 'Shipping address is incorrect' });

        else
            this.setState({ error: null })

        return true;
    }

    countsAreValid = () => {
        var totalCt: number = this.getTotalCount();
        var price: number = this.props.tbanker.price;
        var total: number = (totalCt * price);
        return total <= 10000;  // payment limit
    }

    addressIsVerified = () => {
        return this.state.addressVerifyModel
            && (this.state.addressVerifyModel.addr1 || this.state.addressVerifyModel.addr2)
            && this.state.addressVerifyModel.city
            && this.state.addressVerifyModel.state
            && this.state.addressVerifyModel.zip
            && !this.state.addressVerifyModel.error
    }

    getRecommendedAddressChange = (avm: Tgcc.AddressVerifyModel) => {
        var newState: any = {
            addressVerifyModel: avm
        };

        // swap addr1/addr2 comes in opposite of what we expect
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.addr2 != avm.addr2
            || isBlankOrEmpty(this.state.address1))
            newState.address1 = avm.addr2;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.addr1 != avm.addr1
            || isBlankOrEmpty(this.state.address2))
            newState.address2 = avm.addr1;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.city != avm.city
            || isBlankOrEmpty(this.state.addrCity))
            newState.addrCity = avm.city;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.zip != avm.zip
            || isBlankOrEmpty(this.state.addrZip))
            newState.addrZip = avm.zip;
        if (!this.state.addressVerifyModel
            || this.state.addressVerifyModel.state != avm.state
            || isBlankOrEmpty(this.state.addrState))
            newState.addrState = avm.state;

        return newState.address1
            || newState.address2
            || newState.addrCity
            || newState.addrState
            || newState.addrZip
            || newState.addrState
            ? newState : null
    }

    verifyAddress = () => {
        // trigger validation if we have all the fields entered
        if (this.state.address1 && ((this.state.addrCity && this.state.addrState) || this.state.addrZip)) {
            Request.verifyAddress(this.state.address1, this.state.address2, this.state.addrCity, this.state.addrState, this.state.addrZip,
                // success
                (avm: Tgcc.AddressVerifyModel) => {
                    if (avm.error)
                        this.setState({ error: avm.error });
                    else {
                        var stateChange = this.getRecommendedAddressChange(avm);
                        if (stateChange)
                            this.setState(stateChange, this.allFieldsAreValid);
                    }
                },
                // error
                (err: any) => {
                    console.log("validate address request failed: ", err);
                }
            );
        }
    }

    makePayment = (instance: any, oncomplete: any, showButton: any) => {
        instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
            if (showButton)
                showButton(false);

            if (requestPaymentMethodErr) {
                document.getElementsByClassName("braintree-toggle")[0]['style']["display"] = "inherit"; // show payment change
                console.log("paymentErr: ", requestPaymentMethodErr);
                showButton(true);
                return;
            }
            console.log("Complete payment: ", payload);
            oncomplete(payload);
        });
    }

    disableFields = () => { this.setState({ disableEdits: true }); }
    isHidden = (el) => { if (el == null) return true; return (el.offsetParent === null); }
    showButton = (show) => {
        var button = document.getElementById(paymentButtonId);
        if (button)
            button.style["display"] = show ? "inherit" : "none";
    }

    setupBrainTreeButton = () => {
        var button = document.getElementById(paymentButtonId);
        var price = this.getExtendedPrice();
        var paymentComplete = this.paymentComplete;
        var makePayment = this.makePayment;
        var oncomplete = this.completePayment;
        var fieldsValid = this.allFieldsAreValid;
        var disableFields = this.disableFields;
        var showButton = this.showButton;
        var isHidden = this.isHidden;

        var btDropin = braintree.dropin.create({
            authorization: paymentTokenizationKey,
            container: '#braintree-container',
            dataCollector: { kount: true, paypal: true }
        }, function (createErr, instance) {
            var chkInterval = setInterval(function () {
                if (instance.isPaymentMethodRequestable() && fieldsValid()) {
                    showButton(true);
                    clearInterval(chkInterval);
                } else {
                    showButton(false);
                }
            }, 400);

            button.addEventListener('click', function () {
                if (fieldsValid()) {
                    disableFields();
                    clearInterval(chkInterval);
                    console.log("Request payment setup: ", instance, createErr);
                    makePayment(instance, oncomplete, showButton);
                }
            });
        }
        );
    }

    getCheckout = (): Tgcc.Checkout => {
        var individualShip = this.props.tbanker.shipType == 1 || this.state.individualShip;
        var checkoutData: Tgcc.Checkout = {
            Organization: null,
            IndividualShip: individualShip,
            FirstName: this.state.FirstName,
            LastName: this.state.LastName,
            Email: this.state.Email,
            AddrLine1: individualShip ? this.state.address1 : null,
            AddrLine2: individualShip ? this.state.address2 : null,
            AddrCity: individualShip ? this.state.addrCity : null,
            AddrState: individualShip ? this.state.addrState : null,
            AddrZip: individualShip ? this.state.addrZip : null
        };
        return checkoutData;
    }

    getSizeRec = () => {
        var sizeRec: Tgcc.SizesRec = {
            XSmall: this.state.SizeCounts['XSmall'] ?? 0,
            Small: this.state.SizeCounts['Small'] ?? 0,
            Medium: this.state.SizeCounts['Medium'] ?? 0,
            Large: this.state.SizeCounts['Large'] ?? 0,
            XLarge: this.state.SizeCounts['XLarge'] ?? 0,
            XXL: this.state.SizeCounts['XXL'] ?? 0,
            XXXL: this.state.SizeCounts['XXXL'] ?? 0,
            XXXXL: this.state.SizeCounts['XXXXL'] ?? 0,
            XXXXXL: this.state.SizeCounts['XXXXXL'] ?? 0,
            XXXXXXL: this.state.SizeCounts['XXXXXXL'] ?? 0,

            Infant6: this.state.SizeCounts['Infant6'] ?? 0,
            Infant12: this.state.SizeCounts['Infant12'] ?? 0,
            Infant18: this.state.SizeCounts['Infant18'] ?? 0,
            Infant24: this.state.SizeCounts['Infant24'] ?? 0,

            Toddler2: this.state.SizeCounts['Toddler2'] ?? 0,
            Toddler3: this.state.SizeCounts['Toddler3'] ?? 0,
            Toddler4: this.state.SizeCounts['Toddler4'] ?? 0,
            Toddler5: this.state.SizeCounts['Toddler5'] ?? 0,
            Toddler6: this.state.SizeCounts['Toddler6'] ?? 0,
            Toddler7: this.state.SizeCounts['Toddler7'] ?? 0,

            YXSmall: this.state.SizeCounts['YXSmall'] ?? 0,
            YSmall: this.state.SizeCounts['YSmall'] ?? 0,
            YMedium: this.state.SizeCounts['YMedium'] ?? 0,
            YLarge: this.state.SizeCounts['YLarge'] ?? 0,
            YXLarge: this.state.SizeCounts['YXLarge'] ?? 0,

            OneSize: this.state.SizeCounts['OneSize'] ?? 0,
        }
        return sizeRec;
    }

    completePayment = (data: any) => {
        this.setState({ error: null, isWaiting: true });
        var sizeRec = this.getSizeRec();
        var qty = this.getTotalCount();
        var checkout = this.getCheckout();
        Request.processBraintreePayment(data.nonce,
            data.deviceData,
            this.props.tbanker.code,
            this.props.tbanker.proofId,
            qty,
            sizeRec,
            checkout,
            this.paymentComplete,
            this.paymentFailed);

    }

    paymentComplete = (data: any) => {
        this.setState({ error: "Order Received", isWaiting: false, venmoUser: data.venmoUser, cardNumber: data.cardNumber, purchaseComplete: true, disableEdits: true });
    }

    paymentFailed = (err: string) => {
        document.getElementsByClassName("braintree-toggle")[0]['style']["display"] = "inherit"; // show payment change
        console.log("error processing payment for tbanker: ", err);
        this.setState({ error: err, isWaiting: false, disableEdits: true });
        this.showButton(true);
    }

    braintreeInitialized = false;

    componentDidUpdate() {
        this.handleDynamicEdits();
    }

    handleDynamicEdits = () => {
        var btreeButton = document.getElementById(paymentButtonId);
        if (btreeButton) {
            if (!this.braintreeInitialized) {
                this.braintreeInitialized = true;
                this.setupBrainTreeButton();
            }
        }
    }

    getShipAmount(ct: number): number {

        if (ct > 0 && this.state.individualShip && this.props.tbanker.shipType != Tgcc.ShipmentTypes.Bulk) {
            return this.props.tbanker.firstShipCost + (ct - 1) * this.props.tbanker.additionalShipCost;
        }
        return 0;
    }

    getExtendedPrice = () => {
        var totalCt: number = this.getTotalCount();
        var price: number = this.props.tbanker.price;
        var shipAmount = this.getShipAmount(totalCt);
        var total: number = (totalCt * price) + shipAmount;
        return total;
    }

    freeShipContent = () => {
        // return (
        //     // <div style={proseStyle}>
        //     //     <div style={shipHdrStyle}>Bulk Shipping</div>
        //     //     Thank you for ordering through the<br />Graphic Cow Company.<br /><br />
        //     //     Apparel ordered will be BULK SHIPPED to the individual who organized the design with us.<br /><br />
        //     //     Each item will be bagged & tagged by name and size for easy distribution.<br /><br />
        //     //     Please contact us at 1-800-472-3269 if you have any questions.<br /><br />
        //     //     <div style={szRowStyle}><hr style={hrStyle} /></div>
        //     // </div>
        // )
    }

    handleAddressSelect = (address) => {
        console.log("Selected Address:", address);
        this.setState({
            address1: address.address1,
            address2: address.address2,
            addrCity: address.city,
            addrState: address.state,
            addrZip: address.zipcode
        });
    }
    
    

directShipContent = () => {
    return (
        <div style={{ ...proseStyle, backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
            <div style={{ ...shipHdrStyle, fontFamily: 'CenturyGothic', fontSize: '22px', color: '#2A2A72', marginBottom: '15px' }}>Individual Shipping</div>
            <p style={{ fontFamily: 'CenturyGothic', fontSize: '14px', color: '#333', lineHeight: '1.6', textAlign: 'center' }}>
                Thank you for ordering through the Graphic Cow Company.<br /><br />
                All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                Individually shipped orders will be shipped out in <strong>7-10 business days</strong> after the link has been closed.<br /><br />
                There is an additional shipping fee per item.<br />
                <strong>First Item:</strong> {priceFormatter.format(this.props.tbanker.firstShipCost)}<br />
                <strong>Additional items:</strong> {priceFormatter.format(this.props.tbanker.additionalShipCost)} (each)<br /><br />
                Please contact us at 1-800-472-3269 if you have any questions.<br />
            </p>
            <hr style={{ ...hrStyle, margin: '20px auto', width: '90%' }} />
            <h3 id="shipping">Shipping Address Details:</h3>
            <div id="shippingAddress">
                <AddressAutocomplete
                    placeholder="Address Line 1"
                    inputStyle={inputFieldStyle}
                    className="address-input"
                    key={"addressLine1"}
                    onAddressSelect={this.handleAddressSelect}
                    onInputChange={(value) => this.setState({ address1: value })}
                    addressValue={this.state.address1}
                />
                <input
                    type="text"
                    placeholder="Address Line 2 (Optional)"
                    value={this.state.address2}
                    key={"addressLine2"}
                    onChange={(e) => this.setState({ address2: e.currentTarget.value })}
                    style={inputFieldStyle}
                />
                <input
                    type="text"
                    placeholder="City"
                    value={this.state.addrCity}
                    key={"city"}
                    onChange={(e) => this.setState({ addrCity: e.currentTarget.value })}
                    style={inputFieldStyle}
                />
                <input
                    type="text"
                    placeholder="State"
                    value={this.state.addrState}
                    key={"state"}
                    onChange={(e) => this.setState({ addrState: e.currentTarget.value })}
                    style={inputFieldStyle}
                />
                <input
                    type="text"
                    placeholder="Zip Code"
                    value={this.state.addrZip}
                    key={"zip"}
                    onChange={(e) => this.setState({ addrZip: e.currentTarget.value })}
                    style={inputFieldStyle}
                />
            </div>
        </div>
    );
}

    
    

    setIndividualShip = (turnOn: boolean) => {
        this.setState({ individualShip: turnOn })
    }

    getIndividualShipSection = () => {
        if (this.props.tbanker.shipType == Tgcc.ShipmentTypes.Select) {
            var shipContent = this.state.individualShip ? this.directShipContent() : this.freeShipContent();
            
            // Special handling for proof ID WO789315 (PorchFest pickup)
            if (this.props.tbanker.proofId === 'WO789315') {
                const porchFestHdrStyle = Object.assign({}, hdrStyle, {
                    color: '#666',
                    letterSpacing: '2px',
                    textTransform: 'uppercase' as const,
                    fontWeight: 'normal' as const,
                    fontSize: '14px',
                    marginBottom: '24px'
                });
                const porchFestLabelStyle = Object.assign({}, checkLabelStyle, {
                    color: '#666',
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase' as const,
                    fontSize: '12px',
                    marginBottom: '12px',
                    justifyContent: 'center'
                });
                return (
                    <div>
                        <div style={porchFestHdrStyle}>Choose How To Get Your Shirt</div>
                        <div style={checkRowStyle}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={porchFestLabelStyle}>Pick Up at PorchFest</div>
                                <input style={shipCheckStyle} type="checkbox" checked={!this.state.individualShip} onChange={() => this.setIndividualShip(false)} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={porchFestLabelStyle}>Ship Directly To You</div>
                                <input style={shipCheckStyle} type="checkbox" checked={this.state.individualShip} onChange={() => this.setIndividualShip(true)} />
                            </div>
                        </div>
                        {shipContent}
                    </div>
                )
            }
            
            return (
                <div>
                    <div style={hdrStyle}>Choose your shipping:</div>
                    <div style={checkRowStyle}>
                        <div style={checkLabelStyle}>Bulk Shipping</div>
                        <div style={checkLabelStyle}>Individual</div>
                    </div>
                    <div style={checkRowStyle}>
                        <input style={shipCheckStyle} type="checkbox" checked={!this.state.individualShip} onChange={() => this.setIndividualShip(false)} />
                        <input style={shipCheckStyle} type="checkbox" checked={this.state.individualShip} onChange={() => this.setIndividualShip(true)} />
                    </div>
                    {shipContent}
                </div>
            )
        } else if (this.props.tbanker.shipType == Tgcc.ShipmentTypes.Individual) {
            return this.directShipContent();
        } else {
            return this.freeShipContent();
        }
    }

    getOrderShipLine = (shipping: number) => {
        return shipping > 0 ?
            (<div style={priceRowStyle}>
                <div style={priceLabelStyle}>Shipping:</div>
                <div style={priceValueStyle}>{priceFormatter.format(shipping)}</div>
            </div>) : <div />
    }

    getSizesSection(sectionName: string) {
        let cells = [];
        let sectionHeader;
    
        if (sectionName === 'OneSize') {
            cells.push(this.getSizeCell('OneSize', 0));
            sectionHeader = <div style={sectionHeaderStyle}>One Size</div>;
            return (
                <div style={sizeSectionStyle}>
                    {sectionHeader}
                    <div>
                        {cells}
                    </div>
                </div>
            );
        } else if (sectionName === 'Adult') {
            cells = this.getAdultSizeCells();
            sectionHeader = <div style={sectionHeaderStyle}>Adult Sizes</div>;
        } else if (sectionName === 'Youth') {
            cells = this.getYouthSizeCells();
            sectionHeader = <div style={sectionHeaderStyle}>Youth Sizes</div>;
        }
    
        if (cells.length > 0) {
            return (
                <div style={sizeSectionStyle}>
                    {sectionHeader}
                    <div>
                        {cells}
                    </div>
                </div>
            );
        }
    
        return null; // Return null for no render instead of an empty div
    }
    

    getAdultSizeCells() {
        var cells = [];
        this.props.tbanker.activeAdultSizes.forEach((sz, index) => cells.push(this.getSizeCell(sz, index)));
        return cells;
    }

    getYouthSizeCells() {
        var cells = [];
        this.props.tbanker.activeYouthSizes.forEach((sz, index) => cells.push(this.getSizeCell(sz, index)));
        return cells;
    }

    getSizeCell(szName: string, index: number) {
        var editDisabled = this.state.disableEdits || this.state.purchaseComplete ? true : false;
        var sizeLabel = Tgcc.GetSizeLabel(szName);
        var readableSizeName = this.getReadableSizeName(szName); // You will create this method to convert szName to a user-friendly format
        var childkey = 'key-' + szName + index;
        return (
            <div key={childkey} style={{ ...cellStyle, alignItems: 'center' }}> {/* Align items to the start */}
                <div style={{ ...sizeSectionStyle, marginBottom: '10px' }}>{readableSizeName}:</div>
                <input type="number" name={szName} placeholder="0" min="0" style={numberStyle} onChange={this.handleCountChange} disabled={editDisabled} />
            </div>
        );
    }
    
    getReadableSizeName(sizeCode) {
        const sizeMappings = {
            'XLarge': 'XL',
            'XXL': '2XL',
            'XXXL': '3XL',
            'XXXXL': '4XL',
            'XXXXXL': '5XL',
            'XXXXXXL': '6XL',
            'Infant6': '6mos',
            'Infant12': '12mos',
            'Infant18': '18mos',
            'Infant24': '24mos',
            'Toddler2': '2T',
            'Toddler3': '3T',
            'Toddler4': '4T',
            'Toddler5': '5T',
            'Toddler6': '6T',
            'Toddler7': '7T',
            'YXSmall': 'Youth XS',
            'YSmall': 'Youth S',
            'YMedium': 'Youth M',
            'YLarge': 'Youth L',
            'YXLarge': 'Youth XL',
            'OneSize': 'One Size'
        };
    
        return sizeMappings[sizeCode] || sizeCode;
    }
    

    getOrderFields(price: number, totalCt: number, shipping: number, total: number) {
        var error = this.state.error ? <div style={errorStyle}>{this.state.error}</div> : <div style={errorStyle}></div>;
        var hasBasicInfo = this.state.FirstName && this.state.LastName && this.state.Email && totalCt;
        var canPay = this.braintreeInitialized
            || (!this.state.individualShip && hasBasicInfo)
            || (this.state.individualShip && hasBasicInfo);
        var editDisabled = this.state.disableEdits || this.state.purchaseComplete ? true : false;
    
        let sizeOptions;
        let sizeSubheaders;
        
        if (this.props.tbanker.hCowTag_IsSingleSizeItem) {
          // If single size item is true, render the single size option
          sizeOptions = <div style={sizeSectionStyle}>{this.getSizeCell('OneSize', 0)}</div>;
          sizeSubheaders = (
            <div style={sizesSubheaderStyle}>
              Thank you for ordering with The Graphic Cow Co.
            </div>
          );
        } else {
          // If single size item is false, render all size options
          var adultSizes = this.getSizesSection('Adult');
          var youthSizes = this.getSizesSection('Youth');
          sizeOptions = (
            <div style={sizeSectionStyle} >
              {youthSizes}
              {adultSizes}
            </div>
          );
          sizeSubheaders = (
            <div>
              <div style={sizesSubheaderStyle}>
                Thank you for ordering with The Graphic Cow Co.
              </div>
              <div style={sizesSubheaderStyle}>
                Select as little or as many sizes below and then submit payment to have your shirts labeled with your name and shipped with your organization's order.
              </div>
              <div style={sizesSubheaderStyle}>
                Please contact us at 1-800-472-3269 if you have any questions.
              </div>
            </div>
          );
          
        }
    
        var paymentBox = canPay ?
            <div id="braintree-container" style={{ display: 'flex', flexDirection: 'row', marginLeft: 'auto', marginRight:'auto'}}></div>
            : <div id="braintree-container" style={btppStyle}><img src={Tgcc.ResolveUrl('~/images/paymentbraintree.png')} style={paymentDisabledStyle} /></div>;
        var paymentBtn = canPay ? <div id={paymentButtonId} style={checkoutButtonStyle}>Submit order!</div> : <div></div>;
    
        return (
        <div id="checkout-detail" style={checkoutContainer} className="tbankerCheckOut">
            {this.getIndividualShipSection()}
            <div id="userInfoContainer" style={userInfoContainer}>
                <h1 style={headerStyle}>Your Information</h1>
                <h2 style={subheaderStyle}>Please fill in your information below before adding products so we know how to label your shirts and where to send you a receipt!</h2>
                <div style={userInfoContent}>
                    <div style={userInfoRowStyle}>
                        <input type="text" id="FirstName" name="FirstName" placeholder="First Name" style={userInfoInputStyle} onChange={this.handleFieldChange} value={this.state.FirstName} disabled={editDisabled} />
                    </div>
                    <div style={userInfoRowStyle}>
                        <input type="text" id="LastName" name="LastName" placeholder="Last Name" style={userInfoInputStyle} onChange={this.handleFieldChange} value={this.state.LastName} disabled={editDisabled} />
                    </div>
                    <div style={userInfoRowStyle}>
                        <input type="email" id="Email" name="Email" placeholder="Email Address" style={userInfoInputStyle} onChange={this.handleFieldChange} value={this.state.Email} disabled={editDisabled} />
                    </div>
                </div>
            </div>

            <div style={headerInfoContainerStyle}>
                <div style={sizesHeaderStyle}>Select your Sizes:</div>
                {sizeSubheaders}
            </div>

            <div style={sizeSelectionContainerStyle}>
                {sizeOptions}
            </div>

            <div style={priceTotalContainerStyle}>
                <div style={priceRowStyle}>
                    <div style={priceLabelStyle}>Price per Unit:</div>
                    <div style={priceValueStyle}>{priceFormatter.format(price)}</div>
                </div>
                {this.getOrderShipLine(shipping)}
                <div style={totalRowStyle}>
                    <div style={totalLabelStyle}>Total:</div>
                    <div style={totalValueStyle}>{priceFormatter.format(total)}</div>
                </div>
            </div>
            {error}
            {paymentBox}
            {paymentBtn}
        </div>
    );
}
    
    getCompletionShipLine = (shipping: number) => {
        return shipping <= 0 ? <div /> :
            (<div style={szRowStyle}>
                <div style={szLblStyleStart}>Shipping:</div>
                <div style={szLblStyleSmallEnd}>{priceFormatter.format(shipping)}</div>
            </div>)
    }
    viewRoster = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.CampusProofRoster(this.props.tbanker.proofId))
    }

    getCompletionContent(price: number, totalCt: number, shipping: number, total: number) {
        var buyerLabel = this.state.venmoUser ? "Venmo:" : "Card:";
        var buyerValue = this.state.venmoUser ? this.state.venmoUser : this.state.cardNumber;
        var venmoTag = this.state.venmoUser ? <div style={scriptStyle}>payment received from</div> : <div></div>;
        var venmologo = this.state.venmoUser ? <div style={szRowStyle}><img style={venmoStyle} /></div> : <div></div>;

        return (
            <div id="checkout-detail-order-completed" style={wrapperStyle} className="tbankerCheckOut">
                <div style={scriptStyle}>Order Completed</div>
                <div style={szRowStyle}>
                    <div style={szLblStyleStart}>Email:</div>
                    <div style={szLblStyleSmallEnd}>{this.state.Email}</div>
                </div>
                <div style={szRowStyle}>
                    <div style={szLblStyleStart}>{buyerLabel}</div>
                    <div style={szLblStyleSmallEnd}>{buyerValue}</div>
                </div>
                <div style={szRowStyle}>
                    <div style={szLblStyleStart}>Items ordered:</div>
                    <div style={szLblStyleSmallEnd}>{totalCt.toFixed(0)} @ {priceFormatter.format(price)}</div>
                </div>
                {this.getCompletionShipLine(shipping)}
                <div style={szRowStyle}>
                    <div style={szLblStyle}>Total Paid:</div>
                    <div style={szLblStylePlain}>{priceFormatter.format(total)}</div>
                </div>
                {venmoTag}
                {venmologo}
                <div style={scriptStyle}>Thank you!</div>
                <div style={ckRosterStyle} onClick={this.viewRoster}>Review Roster</div>
            </div>
        )
    }

    render() {
        if (!this.props.tbanker)
            return Tgcc.workingGif;

        if (this.props.tbanker.status == 'CLOSED') {
            return <div style={Tgcc.Styles.grayBanner}>Sorry, T-Banker Is Now Closed</div>
        }

        var totalCt: number = this.getTotalCount();
        var price: number = this.props.tbanker.price;
        var shipping: number = this.getShipAmount(totalCt);
        var total: number = this.getExtendedPrice();

        var completed = this.props.purchaseComplete || this.state.purchaseComplete;
        var pageContent = completed ?
            this.getCompletionContent(price, totalCt, shipping, total)
            : this.getOrderFields(price, totalCt, shipping, total);

        var waitingImg = this.state.isWaiting ? Tgcc.workingGif : null;

        return (
            <StyleRoot>
            <div id="checkout-detail-final" style={checkoutContainer} className="tbankerCheckOut">
                {pageContent}
                {waitingImg}
            </div>
            </StyleRoot>
        );
    }
}
